import React from "react";

import View from "@mui/material/Box"; //rename for portability to React Native
import "./CompleteProfile.css";

import ProfileLateness from "@components/ProfileInterview/ProfileLateness";
import { BackNextBtn } from "components/BackNextBtn/BackNextBtn";
import { CompleteProfileContainer } from "@components/CompleteProfileContainer/CompleteProfileContainer";

export const LatenessComponent = ({ state, handleEditProfile, pushCounter, skipButton, goBack, counter, length }) => {
    return (
        <>
            <CompleteProfileContainer rootContainerClass="question-lateness">
                <View className="top-text"></View>
                <View className="question-container">
                    <ProfileLateness state={state} pushCounter={pushCounter} handleEditProfile={handleEditProfile} />
                </View>
                <BackNextBtn
                    goBack={goBack}
                    counter={counter}
                    length={length}
                    nextBtn={skipButton}
                    pageState={state.lateness}
                />
            </CompleteProfileContainer>
        </>
    );
};
